import _ from "underscore";
import React from "react";
import {styled} from "styled-components";

import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";

import TestsTableRow from "./row";

type Props = {
  organisationId: OrganisationId;
  workflowTests: AggregatedWorkflowTest[];
  filters?: LlmRunQueryParams;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
  hideCols?: Set<"Workflow" | "Issue">;
};

const Table = styled.table`
  thead::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-color: white;
    z-index: -1;
  }
`;

export default function UngroupedTestsTable({
  organisationId,
  workflowTests,
  updateValue,
  hideCols = new Set([]),
}: Props) {
  const sortedTests = _.sortBy(
    workflowTests,
    test =>
      `${test.project_name}:${test.document_name}:${test.clause_reference}`,
  );
  return (
    <Table style={{borderSpacing: "none", width: "100%"}}>
      <thead
        style={{
          position: "sticky",
          top: "0px",
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <tr>
          {!hideCols.has("Workflow") && <th>Workflow</th>}
          {!hideCols.has("Issue") && <th>Issue</th>}
          <th>Project</th>
          <th>Document</th>
          <th>Last Generated</th>
          <th>Runs</th>
          <th>All Pass</th>
          <th>Avg Score</th>
          <th>Links</th>
        </tr>
      </thead>
      <tbody>
        {sortedTests.map(test => (
          <TestsTableRow
            key={`${test.run_links_id}:${test.workflow_id}:${test.config_id}`}
            organisationId={organisationId}
            test={test}
            updateValue={updateValue}
            hideCols={hideCols}
          />
        ))}
      </tbody>
    </Table>
  );
}
